import * as React from "react";

import {
  AppWrapper,
  ExternalLink,
  InfoCard,
} from '@eto/eto-ui-components';

import OpenGraphMeta from "@components/OpenGraphMeta";
import ToolCards from "@components/ToolCards";

const ToolPage = () => {
  return (
    <AppWrapper fromPlatform={true}>
      <InfoCard
        title="Our tools"
        description={
          <p>
            ETO’s tools, dashboards, and visualizations offer data-driven insight into the global
            emerging technology landscape. All tools are designed, developed, and maintained by the {
              <ExternalLink href="https://cset.georgetown.edu/research-topic/data/">data team</ExternalLink>
            } and <ExternalLink href="https://cset.georgetown.edu/research-topics">analysts</ExternalLink> at
            the <ExternalLink href="https://cset.georgetown.edu/">Center for Security and Emerging Technology</ExternalLink>.
          </p>
        }
      >
        <ToolCards />
      </InfoCard>
    </AppWrapper>
  )
}

export default ToolPage

export function Head() {
  return <OpenGraphMeta
    slug="/tools/"
    title="Tools &ndash; Emerging Technology Observatory"
  />
}
